import { InjectionToken } from '@angular/core';
import { TabsetItemDirective } from '../directives/tabset-item.directive';

export type TabsetItemDirectiveType = TabsetItemDirective;

export const TabsetItemDirectiveToken = new InjectionToken<TabsetItemDirectiveType>('TabsetItemDirectiveToken');
